/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FunnelAddressCreateBodyParams } from '../models/FunnelAddressCreateBodyParams';
import type { FunnelAddressCreateResponse } from '../models/FunnelAddressCreateResponse';
import type { FunnelAddressDeleteResponse } from '../models/FunnelAddressDeleteResponse';
import type { FunnelAddressGetResponse } from '../models/FunnelAddressGetResponse';
import type { FunnelAddressListResponse } from '../models/FunnelAddressListResponse';
import type { FunnelAddressUpdateBodyParams } from '../models/FunnelAddressUpdateBodyParams';
import type { FunnelAddressUpdateResponse } from '../models/FunnelAddressUpdateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CrmFunnelsChannelsService {
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @param tenantId
     * @returns FunnelAddressListResponse Ok
     * @throws ApiError
     */
    public static getFunnelChannels(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
        tenantId?: string,
    ): CancelablePromise<FunnelAddressListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/funnel-channels',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
                'tenantId': tenantId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns FunnelAddressCreateResponse Ok
     * @throws ApiError
     */
    public static createFunnelChannel(
        requestBody: FunnelAddressCreateBodyParams,
    ): CancelablePromise<FunnelAddressCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/funnel-channels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns FunnelAddressGetResponse Ok
     * @throws ApiError
     */
    public static getFunnelChannel(
        id: number,
    ): CancelablePromise<FunnelAddressGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/funnel-channels/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns FunnelAddressUpdateResponse Ok
     * @throws ApiError
     */
    public static updateFunnelChannel(
        id: number,
        requestBody: FunnelAddressUpdateBodyParams,
    ): CancelablePromise<FunnelAddressUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/crm/funnel-channels/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param id
     * @returns FunnelAddressDeleteResponse Ok
     * @throws ApiError
     */
    public static deleteFunnelChannel(
        id: number,
    ): CancelablePromise<FunnelAddressDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/crm/funnel-channels/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
